<template>
  	<div class="table-card-wrapper">
		<v-card-title v-if=" show_search ">
			<v-text-field
				v-model="search"
				hide-actions
				append-icon="search"
				:label="getStateWithParam('search')"
				single-line
				hide-details
			></v-text-field>
		</v-card-title>
		<v-data-table
			:data_info="data_info"
			:headers="info_header"
			:items="data_info"
			:search="search"
			class="table-sector"
			:noResultsText="getStateWithParam('no_data')"
			:hide-actions=" hide_actions "
		>
			<template v-slot:items="props">
				<tr :active="props.selecteditem">
					<td @click="getEmrin(props.item)">
						<div>
							<div  v-if=" props.selecteditem && props.selecteditem.kodi == props.item.kodi "
								style="float: right;">
								<v-icon color="green">check</v-icon>
							</div>
							<div>
								{{ props.item.emri }}
							</div>
						</div>
					</td>
					<td v-if="getPropertyFromWhereAreUsed()" class="text-xs-right">{{ props.item.njesia }}</td>
					<td v-if="getPropertyFromWhereAreUsed()" class="text-xs-right">{{ props.item.adresa }}</td>
				</tr>
			</template>
		</v-data-table>
  	</div>
</template>

<script>
export default {
  	name: "TableCard",
  	props: {
		data_temp: {
			type: [Object, Array],
			required: false
		},
		info_header: {
			type: [Object, Array],
			required: false
		},
		from_where: {
			type: [Number],
			required: false,
			default: 1
		},
		show_search: {
			type: [Boolean],
			default: true
		},
		hide_actions: {
			type: [Boolean],
			default: false
		}
  	},
	computed: {
		data_info: function() {
			return this.data_temp;
		}
	},
	methods: {
		getEmrin(item) {
			this.selecteditem = item
			this.$emit("getZonaNameForPaying", item);
		},
		getPropertyFromWhereAreUsed() {
			return this.from_where == 1;
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		}
	},
	data() {
		return {
			search: "",
			selecteditem: null
		};
	}
};
</script>

<style lang="scss">
.table-card-wrapper {
  .v-card__title {
    padding-top: 0;
    .v-input {
      padding: 0;
      margin: 0;
    }
  }
}

table.v-table thead th {
  padding: 0 15px !important;
  text-transform: capitalize;
  color: #2b2b2b !important;
  font-size: 13px;
}

table.v-table tbody td {
  padding: 0 15px !important;
  font-size: 12px;
  font-weight: 300;
}

.theme--light.v-table thead tr:first-child {
  border-bottom: 0 !important;
}

.theme--light.v-table tbody tr:not(:last-child) {
  border-bottom: 0 !important;
}

.theme--light.v-table tbody tr:last-child {
  border-bottom: 0 !important;
}

.theme--light.v-table tbody tr:nth-child(even) {
  background-color: white;
}

.theme--light.v-table tbody tr:nth-child(odd) {
  background-color: #f2f2f2;
}

.theme--light.v-table tbody tr:hover {
  background: none !important;
}

.theme--light.v-datatable .v-datatable__actions {
  border-top: 0 !important;
  .v-datatable__actions__range-controls {
    width: 100%;
    display: flex;
    justify-content: space-between;
    .v-datatable__actions__pagination {
      order: 2;
      color: #2b2b2b !important;
      font-size: 13px;
    }
    [aria-label="Previous page"] {
      order: 1;
    }
    [aria-label="Next page"] {
      order: 3;
    }
  }
}

.v-datatable__actions__select {
  display: none !important;
}
</style>


